import React from 'react'
import { Chip } from '@material-ui/core'
import { useTrans } from '../../../../services/i18n'

const StatusChip = ({ status }) => {
  const { trans } = useTrans()

  const getStatusProps = (status) => {
    switch (status?.toLowerCase()) {
      case 'new':
        return {
          label: trans('new'),
          style: { backgroundColor: '#007bff', color: '#fff', fontFamily: 'Manrope', fontSize: '12px', fontWeight: '700', fontStretch: 'normal', fontStyle: 'normal', lineHeight: 'normal', padding: '15px 10px', borderRadius: '14px', letterSpacing: 'normal', border: 'none' }
        }
      case 'progress':
        return {
          label: trans('progress'),
          style: { backgroundColor: '#ffac00', color: '#fff', fontFamily: 'Manrope', fontSize: '12px', fontWeight: '700', fontStretch: 'normal', fontStyle: 'normal', lineHeight: 'normal', padding: '15px 10px', borderRadius: '14px', letterSpacing: 'normal', border: 'none' }
        }
      case 'completed':
        return {
          label: trans('completed'),
          style: { backgroundColor: '#28a745', color: '#fff', fontFamily: 'Manrope', fontSize: '12px', fontWeight: '700', fontStretch: 'normal', fontStyle: 'normal', lineHeight: 'normal', padding: '15px 10px', borderRadius: '14px', letterSpacing: 'normal', border: 'none' }
        }
      case 'deleted':
        return {
          label: trans('deleted'),
          style: { backgroundColor: '#dc3545', color: '#fff', fontFamily: 'Manrope', fontSize: '12px', fontWeight: '700', fontStretch: 'normal', fontStyle: 'normal', lineHeight: 'normal', padding: '15px 10px', borderRadius: '14px', letterSpacing: 'normal', border: 'none' }
        }
      default:
        return {
          label: status || trans('unknown'),
          style: { backgroundColor: '#F8F9FA', color: '#6C757D', fontFamily: 'Manrope', fontSize: '12px', fontWeight: '700', fontStretch: 'normal', fontStyle: 'normal', lineHeight: 'normal', padding: '15px 10px', borderRadius: '14px', letterSpacing: 'normal', border: 'none' }
        }
    }
  }

  const statusProps = getStatusProps(status)

  return (
    <Chip
      size="small"
      variant="outlined"
      {...statusProps}
    />
  )
}

export default StatusChip
